import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QuestionTypeBaseComponent } from '../../../base/question-type-base.component';
import { FormBuilder } from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ValidationService} from '@medrecord/services-form-validation';
import { isNumber } from '../../../utils/is-number.util';

@Component({
  selector: 'medrecord-question-integer',
  templateUrl: './question-integer.component.html',
  styleUrls: ['./question-integer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionIntegerComponent extends QuestionTypeBaseComponent {
  @Input() isPositiveHealth = false;

  constructor(
    protected fb: FormBuilder,
    protected translateService: TranslateService,
    protected validatorsService: ValidationService,
  ) {
    super(fb);
  }

  get integerInputWidth() {
    return this.question.unitOfMeasure ? 130 : 80;
  }

  initForm(): void {
    this.form = this.fb.group({
      answer: [
        isNumber(this.currentAnswer) ? this.currentAnswer : null,
        [
          this.validatorsService.decimalNumber(this.translateService.instant('validation.only_number')),
          this.validatorsService.minLength(
            this.question.options.minValue,
            this.translateService.instant('validation.min', { number: this.question.options.minValue })
          ),
          this.validatorsService.maxLength(
            this.question.options.maxValue,
            this.translateService.instant('validation.max', { number: this.question.options.maxValue })
          ),
        ]
      ]
    });
  }

  getCurrentAnswerText(answer: any): string {
    if (typeof answer === 'number') {
      return `${answer} ${this.question.unitOfMeasure || ''}`.trim();
    }

    return '';
  }

}
